{
    "SectionheaderDatetime": "Date / Time",
    "SectionheaderTimerange": "Time Range",
    "SectionheaderDaterange": "Custom Date/Time Range",
    "SectionheaderDaysoftheweek": "Days of the week",
    "SectionHeaderLastXDays": "Last 'X' Days",
    "InputlabelBetween": "Between:",
    "InputlabelAnd": "And:",
    "RadiolabelRealtime": "Real-time (Now)",
    "RadiolabelToday": "Today",
    "RadiolabelYesterday": "Yesterday",
    "RadiolabelThisweek": "This week",
    "RadiolabelLastweek": "Last week",
    "RadiolabelThismonth": "This month",
    "RadiolabelLastmonth": "Last month",
    "RadiolabelCustom": "Custom...",
    "RadiolabelLastXDays": "Last 'X' Days",
    "RadiolabelDays": "Days:",
    "NAME": "DateTime"
}